import PromiseRequest from "../req/PromiseRequest";
import {IImportFormat} from "../index";
import {ImportFormatId} from "../constants/ImportFormats";

export class ImportFormatManager {

    private readonly req_getimportformats = new PromiseRequest('getimportformats')
    /** Empty until {@link init} resolves (login awaits that before routing). */
    public data: IImportFormat[] = [];

    constructor() {
    }

    init() {
        return this.req_getimportformats
            .request()
            .then((data: IImportFormat[]) => {
                this.data = data
            })
    }

    getImportFormatById(id: ImportFormatId): IImportFormat | undefined {
        return this.data.find(o => o.id == id)
    }
}